import { FC } from 'react'

const Header: FC = () => {
    return (
        <header className="header">
            <div className="header__title">
                <h3>Что-то в чём-то</h3>
            </div>
            <div className="header__subtitle">
                <div className="header__subtitle-ru">
                    <p>В этом калькуляторе вы можете просчитать сколько предметов меньшего размера поместится в больший. Например бургеров в комнате или вещей в коробке.</p>
                </div>
                <div className="header__subtitle-en">
                    <p>In this calculator, you can calculate how many smaller items will fit in a larger one. For example, burgers in a room or things in a box.</p>
                </div>
            </div>
        </header>
    )
}

export default Header